import React, { useRef } from "react";
import { IoCloseOutline } from "react-icons/io5";

function Modal({ isOpen, onClose, children, isSubmitting, contentType }) {
  const modalRef = useRef(null);

  if (!isOpen) return null;

  const isVideo = contentType === "video";

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div
        ref={modalRef}
        className={`bg-white rounded-2xl shadow-2xl ${isVideo ? "max-w-4xl" : "max-w-lg"} w-full max-h-[90vh] overflow-y-auto relative`}
        onClick={(e) => e.stopPropagation()}
      >
        {isSubmitting && (
          <div className="absolute inset-0 bg-white/80 z-10 flex items-center justify-center rounded-2xl">
            <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
          </div>
        )}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-all z-20"
        >
          <IoCloseOutline className="w-5 h-5" />
        </button>
        <div className="p-6">
          {children}
        </div>
      </div>
    </div>
  );
}

export default Modal;
